export default __webpack_public_path__ + "static/media/bravo_logo.6c8e3a53.png";